/* Johnny Fly launch loader: real code lives in launch-dawn-app.js */
(function(){var s=document.createElement('script');s.src='https://cdn.shopify.com/s/files/1/0115/2792/files/launch-dawn-app.js?v='+Math.floor(Date.now()/300000);document.head.appendChild(s);})();
